import React from 'react'
import styles from './styles.css'
import Button from 'orionsoft-parts/lib/components/Button'
import PropTypes from 'prop-types'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'
import { withRouter } from "react-router"
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import autobind from 'autobind-decorator'

@withRouter
@withMutation(gql`
  mutation notifyComplete($documentId: ID) {
    notifyComplete(documentId: $documentId) {
      success
    }
  }
`)

@withMessage
export default class Resend extends React.Component{

  static propTypes = {
    showMessage: PropTypes.func,
    document: PropTypes.object,
    notifyComplete: PropTypes.func
  }
  state = {}

  @autobind
  async enviarNotifyComplete() {
    console.log("Llamando notifyComplete")
    console.log("props", this.props);
    this.setState({loading: true})
      try {
        await this.props.notifyComplete(
          {
            documentId: this.props.document._id
          }
        )
        this.props.showMessage('Documento reenviado')
      } catch (e) {
        console.log("No pude llamar", e);
      }
      this.setState({loading: false})
    }
    render() {
        console.log("Props?", this.props);
        return (
          <div className={styles.container}>
            <Button primary loading={this.state.loading} onClick={this.enviarNotifyComplete}>
              Reenviar Documento
            </Button>
          </div>
        )
      }
}


// WEBPACK FOOTER //
// ./src/App/Pages/Documents/Document/Ready/Title/Buttons/Resend/index.js